"use client";

import { useEffect } from "react";

export default function OneSignalProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    // Only initialize OneSignal if the app ID is provided
    if (!process.env.NEXT_PUBLIC_ONESIGNAL_APP_ID) {
      console.log("OneSignal disabled - no app ID provided");
      return;
    }

    const initOneSignal = async () => {
      try {
        // Dynamic import to avoid SSR issues
        const OneSignal = (await import("react-onesignal")).default;
        
        await OneSignal.init({
          appId: process.env.NEXT_PUBLIC_ONESIGNAL_APP_ID!,
          allowLocalhostAsSecureOrigin: true,
          notifyButton: {
            enable: true,
            prenotify: true,
            showCredit: false,
            text: {
              "tip.state.unsubscribed": "Subscribe to notifications",
              "tip.state.subscribed": "You are subscribed to notifications",
              "tip.state.blocked": "You have blocked notifications",
              "message.prenotify": "Click to subscribe to notifications",
              "message.action.subscribing": "Subscribing...",
              "message.action.subscribed": "Thanks for subscribing!",
              "message.action.resubscribed": "You are now subscribed to notifications",
              "message.action.unsubscribed": "You will no longer receive notifications",
              "dialog.main.title": "Manage your notification settings",
              "dialog.main.button.subscribe": "SUBSCRIBE",
              "dialog.main.button.unsubscribe": "UNSUBSCRIBE",
              "dialog.blocked.title": "Unblock Notifications",
              "dialog.blocked.message": "Follow these instructions to allow notifications:"
            }
          },
          // Reduce cookie usage by using localStorage when possible
          persistNotification: false,
          // Disable automatic subscription to reduce cookie usage
          autoRegister: false,
        });
      } catch (error) {
        console.warn("OneSignal initialization failed:", error);
      }
    };

    if (typeof window !== "undefined") {
      initOneSignal();
    }
  }, []);

  return <>{children}</>;
}
